import { User } from '@shared/models';
import { WMPerm } from '@walmart/constants';

export function canViewAnySupplierManagement(user: User) {
  return (
    hasGlobalStoresSubmenu(user) ||
    user.hasPermission(WMPerm.ViewSupplierMgmtAllPOs) ||
    user.hasPermission(WMPerm.ViewSupplierMgmtGlobalStores) ||
    user.hasPermission(WMPerm.ViewSupplierMgmtGlobalSuppliers) ||
    user.hasPermission(WMPerm.ViewSupplierMgmtOTIF)
  );
}

export function hasGlobalStoresSubmenu(user: User) {
  return (
    user.hasPermission(WMPerm.ViewSupplierMgmtFixtureDistributions) ||
    user.hasPermission(WMPerm.ViewSupplierMgmtFixtureReplenishment) ||
    user.hasPermission(WMPerm.ViewSupplierMgmtFixtureSpecialProjects) ||
    user.hasPermission(WMPerm.ViewSupplierMgmtFixtureMajorProjects) ||
    user.hasPermission(WMPerm.ViewSupplierMgmtPreConProjects) ||
    user.hasPermission(WMPerm.ViewSupplierMgmtStoreRequests)
  );
}

export function hasManagementReportsSubmenu(user: User) {
  return (
    user.hasPermission(WMPerm.ViewStoreProjectOTIF) ||
    user.hasPermission(WMPerm.ViewQuotesByProjectType) ||
    user.hasPermission(WMPerm.View24HourParts) ||
    user.hasPermission(WMPerm.ViewSupplierCompliance) ||
    user.hasPermission(WMPerm.ViewAssetErrors) ||
    user.hasPermission(WMPerm.ViewPreConQuotes)
  );
}

export function hasAdminSubmenu(user: User) {
  return (
    user.hasPermission(WMPerm.ViewPartnerAdmin) ||
    user.hasPermission(WMPerm.ViewUserAdmin) ||
    user.hasPermission(WMPerm.ViewItemAdmin) ||
    user.hasPermission(WMPerm.ViewPOAdmin) ||
    user.hasPermission(WMPerm.ViewAssetAdmin)
  );
}

export function hasStoreQuotesSubmenu(user: User) {
  return (
    user.hasPermission(WMPerm.ViewStoreQuotes) ||
    user.hasPermission(WMPerm.ViewQuoteAdmin) ||
    user.hasPermission(WMPerm.ViewSupplyChainReport) ||
    user.hasPermission(WMPerm.ViewRevisionReasonsReport) ||
    user.hasPermission(WMPerm.ViewRejectionReasonsReport) ||
    user.hasPermission(WMPerm.ViewProtoReset)
  );
}

export function hasStoreInformationSubmenu(user: User) {
  return user.hasPermission(WMPerm.ViewStoreProjects) || user.hasPermission(WMPerm.ViewGCCLog) || user.hasPermission(WMPerm.ViewLeadTimeViolations);
}
